// Don't use `rem` units for anything since existing CSS `font-size` affects all rem units
// https://github.com/am-systems/am-web-properties/blob/c1d44502a5babfe955a7f7462eba23658a73bbe3/public/thecreditreview/css/top-services/media-query.css#L22-L25.
// Existing `rem` units are migrated values from old styles to avoid breaking layouts.
export const getStyles = ({ companyIndex }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw-bg-[#ebf4ff] tw-text-center tw-text-balance tw-rounded-t-[3px]",
		contentWrapper:
			"tw-text-black tw-font-bold tw-leading-[2rem] tw-text-[16px]",
	},
	serviceFlag: {
		wrapper: "tw-absolute tw-top-[9px] tw-left-[-5px] tw-flex",
		flag: `tw-w-[24px] tw-h-[24px] tw-bg-[#1d8ce0] tw-shadow-[1px_3px_3px_lightgrey] tw-flex tw-items-center tw-justify-center tw-rounded-[3px] xs2:tw-w-[28px] xs2:tw-h-[28px] xs2:tw-p-0 tw-border-[1px] tw-border-solid  tw-border-[#1d8ce0]`,
		number:
			"tw-text-white tw-text-[12px] tw-font-[AvenirNextLTPro-Demi] tw-m-0 tw-pt-[2px] xs2:tw-text-[14px] tw-leading-[1.4286]",
		text: "tw-relative tw-ml-[0.25rem] tw-h-[24px] tw-border-l-2 tw-text-white tw-py-[0.5rem] tw-pl-[0.75rem] tw-flex tw-items-center tw-justify-center tw-bg-[#1d8ce0] tw-text-[12px] tw-font-semibold tw-leading-[15px] tw-shadow-[1px_3px_3px_lightgrey] xs2:tw-h-[28px] xs2:tw-text-[13px] after:tw-relative after:tw-left-[6px] after:tw-w-[22px] after:tw-inset-0 after:[border-right:13px_solid_white] after:[border-top:12px_solid_#1e8ce0] after:[border-bottom:12px_solid_#1e8ce0] xs2:after:[border-right:15px_solid_white] xs2:after:[border-top:14px_solid_#1e8ce0] xs2:after:[border-bottom:14px_solid_#1e8ce0]",
	},
	companyLogo: {
		picture: "tw-contents",
		image: "tw-max-w-[70%] desktop:tw-max-w-[160px]",
	},
	trustpilotReview: {
		container:
			"tw-flex tw-flex-col tw-w-fit tw-text-center tw-min-w-[118px] tw-max-w-[120px] desktop:tw-mt-[20px]",
		reviewCount:
			"tw-text-[#232227] tw-font-semibold tw-text-center tw-text-[13px] tw-leading-[1.4286] xs2:tw-text-[14px]",
		reviewCountNumber: "tw-font-bold [font-family:Graphik_Web]",
		reviewCountText: "tw-font-normal",
		ratingContainer: "tw-my-[4px] tw-flex tw-gap-[3px] tw-justify-center",
		starBase:
			"tw-relative tw-rounded-[3px] tw-w-[18px] tw-h-[18px] tw-flex tw-items-center tw-justify-center tw-text-white tw-text-[12px] xs2:tw-text-[14px] xs2:tw-w-[21px] xs2:tw-h-[21px]",
		ratingCountWrapper: "tw-w-full tw-flex tw-items-end tw-justify-evenly",
		ratingCount: "tw-font-bold tw-text-[14px] tw-text-[#232227] tw-leading-[1]",
		ratingCountText: " tw-text-[14px] tw-text-[#232227] tw-leading-[1]",
		trustPilotLogo: "tw-h-[16px] tw-w-auto",
	},
	columnInformation: {
		wrapper: "tw-grid tw-w-full tw-items-center",
		columnWrapper:
			"tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-content-center tw-flex-wrap tw-pb-[1.25rem] tw-text-center tw-text-[13px] tw-leading-[1.4286] tw-font-semibold tw-text-[#232227] xs2:tw-text-[16px] desktop:tw-flex-row desktop:tw-pb-0",
		column: "tw-px-[5px] tw-flex tw-flex-col tw-justify-between desktop:tw-p-0",
		label:
			"tw-w-full tw-h-auto tw-pb-[5px] tw-font-[Montserrat] tw-text-[11px] tw-text-[#787e81] tw-uppercase tw-font-semibold tw-tracking-[0.05em] xs2:tw-tracking-[0.08em] desktop:tw-hidden tw-leading-[1.4286]",
		value:
			"tw-text-[13px] tw-leading-[1.4286] tw-font-semibold tw-text-[#232227] tw-text-center xs2:tw-text-[16px]",
	},
	benefitsList: {
		wrapper: "",
		list: `tw-mx-0 tw-mt-0 tw-max-w-full desktop:tw-max-w-[305px] tw-text-[14px] desktop:tw-mb-0 desktop:tw-text-[13px] lg2:tw-text-[16px] tw-flex tw-flex-col ${companyIndex === 0 ? "tw-mb-[5px]" : "tw-mb-0"}`,
		listItem: `tw-mt-0 tw-mb-[6px] tw-mx-0 tw-pl-[25px] tw-text-[#48484b] tw-text-[14px] tw-font-semibold tw-leading-[1.4286] tw-bg-[url(/public/react-images/common/iconTick.svg)] tw-bg-no-repeat tw-bg-[left_top_5px] ${companyIndex === 0 ? "[&:last-child]:tw-mb-0" : ""}`,
		expandButton:
			"tw-mb-0 tw-mt-[5px] tw-w-full tw-mx-auto tw-flex tw-cursor-pointer tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-pl-[25px] tw-text-[#48484b] md:tw-mt-[1.25rem]",
		expandBenefitsContent: "tw-text-[13px] tw-pt-[2px]",
		expandButtonIcon: "tw-ml-[8px] tw-text-[16px] tw-rotate-90",
	},
	reviewLink: {
		wrapper:
			"tw-text-center tw-table tw-text-[#1d8ce0] tw-text-[14px] tw-font-semibold tw-leading-[1.4286] desktop:tw-mx-auto [border-bottom:1px_dashed] tw-mt-[10px]",
		text: "",
	},
});
